import { render } from "./ModulInfoVideo.vue?vue&type=template&id=5cfa4716"
import script from "./ModulInfoVideo.vue?vue&type=script&lang=js"
export * from "./ModulInfoVideo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__